import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({

    en: {
        read: "Read more",
        title:"Our daily commitments",
        content:"We are committed to creating space for learning, innovation and courageous conversations on topics related to equity, diversity, and inclusion.",
        chosing: {
            title: "Choosing EDI",
            content: "We will recognize and remove barriers by applying an EDI lens in all parts of our work.",
            button: "Read More",
            link: "",
            more: "We believe that equity, diversity and inclusion make us stronger as an organization and a better public broadcaster for Canadians. We adopt strategies that allow us to lead a sustainable transformation. We are purposeful about tracking success and remain open to continuous learning and improvement."
        },
        forall: {
            title: "Content for all",
            content: "We will ensure our content reflects the experiences of all people living in Canada.",
            button: "Read More",
            link: "",
            more:"We’re taking a fresh look at the content we produce and commission to improve representation of creators from across our society and to ensure a diversity of perspectives. We believe that for our content to be the best, it must reflect the experiences of our audiences, our content creators, and our employees. This means challenging ourselves to reach underrepresented communities and tell new stories, while recognizing that we need to rebuild trust where it is lacking. These new stories will be professional and accurate while also creating space for authenticity.",
            alt:"Photo of the show Sort Of",
            legend:""
        },
        workplace: {
            title: "Workplace culture",
            content: "We will foster EDI as a value shared and owned by everyone at CBC/Radio-Canada.",
            button: "Read more",
            secondaryButton: "How we are doing",
            link: "",
            secondaryLink: "#stats",
            more:"Diverse and inclusive teams drive innovation and are more successful. As an organization, we create spaces to learn, grow and collaborate. We also provide ongoing opportunities and support for all employees to ensure equity, diversity and inclusion in their everyday work.",
            alt:"Photo of Céline Galipeau at the evening news.",
            legend:""
        },
        communities: {
            title: "Connected to communities",
            content: "We will connect with underrepresented communities to better understand and meet their expectations and needs regarding CBC/Radio-Canada.",
            button: "Read more",
            link: "",
            more: "To better serve Canadians and ensure their voices are heard and realities are reflected in our content, we must be intentional about building closer connections with diverse communities, particularly those that are underrepresented."

        },
        communications: {
            title: "Straightforward communications",
            content: "We will ensure accountability through openness and regular and authentic communication that unite us under a common vision.",
            button: "Read more",
            link: "",
            more: "Accountability and transparency are essential to supporting our EDI work at CBC/Radio-Canada. We will share our vision for EDI and keep Canadians informed of our progress. Our communications will support EDI engagement within the organization and externally, while encouraging broader discussions about EDI across the media industry."
        }



    },
    fr: {
        read: "En savoir plus",
        title:"Nos engagements au quotidien",
        content:"Nous sommes résolus à créer un espace pour l’apprentissage, l’innovation et les conversations courageuses sur tous les sujets touchant l’équité, la diversité et l’inclusion.",
        chosing: {
            title: "Choisir l’EDI",
            content: "Nous reconnaîtrons et nous ferons tomber les barrières en plaçant l’équité, la diversité et l’inclusion au cœur de tout ce que nous faisons.",
            button: "En savoir plus",
            more:"Nous croyons que l’équité, la diversité et l’inclusion font de nous une organisation plus forte et un meilleur diffuseur public au service de la population canadienne. Nous adoptons des stratégies qui nous permettent d’opérer une transformation durable. Mesurer notre progression est pour nous un impératif, et nous demeurons ouverts à l’apprentissage et à l’amélioration continus.",
            link: ""
        },
        forall: {
            title: "Des contenus inclusifs",
            content: "Nous veillerons à ce que nos contenus reflètent le vécu de toutes les personnes habitant au Canada.",
            button: "En savoir plus",
            more:"Nous jetons un regard neuf sur les contenus que nous produisons ou commandons, dans l’intention de mieux représenter les créateurs et les créatrices de tous horizons et de garantir une variété de points de vue. Nous croyons que pour offrir les meilleurs contenus possible, nous devons refléter les expériences de nos auditoires, de nos créateurs et créatrices de contenu et des membres de notre effectif – une ambition qui nous met au défi de joindre les communautés sous-représentées et de renouveler nos récits et reportages, tout en reconnaissant la nécessité de rétablir la confiance là où elle fait défaut. Ces nouveaux récits et reportages allieront professionnalisme et exactitude, tout en laissant la place à l’authenticité.",
            link: "",
            alt:"Photo de la série Sort Of",
            legend:""
        },
        workplace: {
            title: "Culture interne",
            content: "Nous favoriserons l’adoption des valeurs d’EDI par tous les membres de nos équipes.",
            button: "En savoir plus",
            secondaryButton: "Nos résultats à ce jour",
            more:"La diversité et l’inclusion sont des facteurs d’innovation et de réussite dans nos équipes. En tant qu’organisation, nous créons des espaces propices à l’apprentissage, à l’épanouissement et à la collaboration. Et pour que l’équité, la diversité et l’inclusion fassent partie de leur quotidien au travail, nous offrons à tous les membres de notre effectif des possibilités de développement et un soutien continus.",
            link: "",
            secondaryLink: "#stats",
            alt:"Photo de Céline Galipeau au Téléjournal",
            legend:""
        },
        communities: {
            title: "Branchés sur les communautés",
            content: "Nous irons à la rencontre des communautés sous-représentées pour mieux comprendre leurs attentes envers CBC/Radio-Canada et répondre à leurs besoins.",
            button: "En savoir plus",
            more:"Pour mieux servir les Canadiennes et les Canadiens et faire en sorte que leurs voix soient entendues et leurs réalités reflétées dans nos contenus, nous devons sciemment tisser des liens plus étroits avec les diverses communautés du pays, en particulier celles qui sont sous-représentées.",
            link: ""
        },
        communications: {
            title: "Des communications franches ",
            content: "Nous rendrons compte de nos actions en cultivant l’ouverture et au moyen de communications régulières et authentiques, qui nous rallient autour d’une vision commune.",
            button: "En savoir plus",
            more:"La responsabilisation et la transparence contribuent de façon essentielle à nos efforts en matière d’EDI. Nous exposerons notre vision de l’EDI et relaierons nos progrès auprès de la population canadienne. Nos communications viendront appuyer notre engagement en faveur de l’EDI tant au sein de l’organisation qu’à l’externe, tout en stimulant la discussion sur l’EDI dans l’industrie des médias.",
            link: ""
        }
    }
});

export default strings;